import { X } from 'lucide-react';
import type { HTMLAttributes, ReactNode } from 'react';
import { toast } from 'sonner';
import { cn } from '~/lib/utils';

type ToastLayoutProps = Omit<HTMLAttributes<HTMLDivElement>, 'title'> & {
  title: ReactNode;
  icon: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  borderColor?: string;
  toastId?: string | number;
};

export function ToastLayout({
  title,
  icon,
  children,
  className,
  contentClassName,
  borderColor = 'border-line-300',
  toastId,
  ...props
}: ToastLayoutProps) {
  return (
    <div
      className={cn(
        'rounded-lg border bg-background-0 p-md drop-shadow-md',
        'flex items-center justify-center gap-md',
        borderColor,
        className
      )}
      {...props}
    >
      {icon}
      <div className={cn('flex flex-1 flex-col justify-center gap-xs', contentClassName)}>
        <h2 className="text-h2">{title}</h2>
        {children}
      </div>

      {toastId !== undefined ? (
        <button
          onClick={() => toast.dismiss(toastId)}
          className="
            hidden size-4 items-center justify-center rounded-sm
            transition-colors
            hover:bg-background-100
            sm:flex
          "
          aria-label="Close"
          type="button"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>
  );
}
